<template>
	<span>
		{{ message }}
		<a v-if="months" @click="widen">Suche erweitern</a>
	</span>
</template>

<script>

// The next wider range for each 12/6/3-Monate selection.
const widerRange = { 3: 6, 6: 12, 12: undefined };

const formatDate = (date) => date.toLocaleDateString("de-DE", {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
});

export default {
	name: "EmptyRange",
	props: {
		// What the list holds, as in "Keine <noun> zwischen dem ...".
		noun: {
			type: String,
			default: "Einträge",
		},
	},
	computed: {
		months() {
			return this.$store.getters.getChartMonths;
		},
		message() {
			if (!this.months) return `Keine ${this.noun}!`;
			// Same arithmetic as the range subscriptions.
			const start = new Date();
			start.setMonth(start.getMonth() - this.months);
			return `Keine ${this.noun} zwischen dem ${formatDate(start)}`
				+ ` und dem ${formatDate(new Date())}.`;
		},
	},
	methods: {
		widen() {
			this.$store.dispatch("setChartMonths", widerRange[this.months]);
		},
	},
};
</script>
